import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from '@heroui/react';
import { ArrowLeft2 } from 'iconsax-react';
import { SetURLSearchParams } from 'react-router-dom';
import { useKeyboardVisibility } from '@shared/hooks/use-keyboard-visibility.ts';
import { PriceRangeInput } from '@ui/product/price-range-input.ui.tsx';
import { ManufacturerPicker } from '@ui/product/manufacturer-picker.tsx';

export const ProductFiltersModal = ({
  isOpen,
  onOpenChange,
  onClose,
  searchParams,
  setSearchParams,
}: {
  isOpen?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  onClose?: () => void;
  searchParams: URLSearchParams;
  setSearchParams: SetURLSearchParams;
}) => {
  const isVisible = useKeyboardVisibility('visibility');
  return (
    <Modal
      onOpenChange={onOpenChange}
      size="full"
      disableAnimation
      hideCloseButton
      isOpen={isOpen}
    >
      <ModalContent>
        <ModalHeader className="border-b py-1 px-0 flex flex-row items-center">
          <Button isIconOnly variant="light" onPress={onClose}>
            <ArrowLeft2 size="24" color="#222222" />
          </Button>
          Фильтры
        </ModalHeader>
        <ModalBody>
          <PriceRangeInput searchParams={searchParams} />

          <ManufacturerPicker />
        </ModalBody>
        {!isVisible && (
          <ModalFooter>
            <Button
              variant="solid"
              radius="lg"
              color="primary"
              fullWidth
              size="lg"
              onPress={() => {
                setSearchParams(searchParams);
                onClose?.();
              }}
            >
              Показать
            </Button>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};
